import { useState, type ReactNode } from "react";
import { PenSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { ReviewForm } from "@/components/ReviewForm";

interface ProductReviewDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  trigger?: ReactNode;
}

export function ProductReviewDialog({ open: openProp, onOpenChange, trigger }: ProductReviewDialogProps = {}) {
  const [internalOpen, setInternalOpen] = useState(false);
  const open = openProp ?? internalOpen;
  const setOpen = onOpenChange ?? setInternalOpen;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      {trigger !== null && (
        <DialogTrigger asChild>
          {trigger ?? (
            <Button size="lg" variant="outline" className="min-h-12">
              <PenSquare className="mr-2 h-4 w-4" /> Write a Review
            </Button>
          )}
        </DialogTrigger>
      )}
      <DialogContent className="max-h-[90dvh] w-[calc(100%-1.5rem)] max-w-2xl overflow-y-auto overscroll-contain p-0 sm:w-full">
        <DialogHeader className="sr-only">
          <DialogTitle>Review Brain Charge™</DialogTitle>
          <DialogDescription>Share an honest Brain Charge experience for verification and moderation.</DialogDescription>
        </DialogHeader>
        <ReviewForm defaultProduct="brainCharge" lockProduct embedded />
      </DialogContent>
    </Dialog>
  );
}
